import { isEmpty } from 'lodash'

/**
 * Filter users based on the city name specified in cityFilter
 * This checks if the user has the specified city in their cities array
 * @param {Object} cityFilter - The city filter object with a label property
 * @returns {Function} A filter function that returns true for users with matching city
 */
export const filterUserWithCityName = (cityFilter) => {
  // If no city filter is applied, let all users through
  if (!cityFilter || isEmpty(cityFilter)) {
    return () => true;
  }
  
  // Get the normalized filter text
  const filterText = cityFilter.label ? cityFilter.label.toLowerCase() : '';
  
  if (!filterText) {
    return () => true;
  }

  return (user) => {
    // Handle edge cases with missing data
    if (!user) return false;
    
    // If user doesn't have cities data, check other possible city fields
    if (!user.cities || !Array.isArray(user.cities)) {
      // Try to find city info in other possible fields
      const cityFromLocation = user.location?.city || user.city;
      if (cityFromLocation) {
        return cityFromLocation.toLowerCase().includes(filterText);
      }
      
      return false;
    }

    // More flexible matching - check if any city name contains the filter text
    // or if filter text contains any city name
    return user.cities.some(city => {
      if (!city) return false;
      
      const cityLower = city.toLowerCase();
      
      // Check both ways - city contains filter text or filter text contains city
      const cityContainsFilter = cityLower.includes(filterText);
      const filterContainsCity = filterText.includes(cityLower);
      
      // Check for partial word matches (e.g. "Toronto" should match "North York, Toronto")
      const cityWords = cityLower.split(/[\s,]+/);
      const filterWords = filterText.split(/[\s,]+/);
      const hasWordMatch = cityWords.some(word => filterWords.includes(word)) || 
                           filterWords.some(word => cityWords.includes(word));
                           
      return cityContainsFilter || filterContainsCity || hasWordMatch;
    });
  };
}

export default filterUserWithCityName
